"use client";
import React, { createContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { BASE_URL, UPLOAD_URL } from "../config/apiConfig";

export const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ Fetch single product
  useEffect(() => {
    if (!id) return;
    setLoading(true);

    fetch(`${BASE_URL}/products/${id}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 200 && data.data) {
          const p = data.data;
          setProduct({
            id: p.id,
            name: p.name,
            content: p.content,
            price: p.price,
            category_name: p.category_name,
            image: `${UPLOAD_URL}/products/${p.image}`,
            details: Array.isArray(p.details) ? p.details : [],
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching product:", err);
        setLoading(false);
      });
  }, [id]);

  // ✅ Fetch all products
  useEffect(() => {
    if (id) return; // prevent fetching all when single page
    setLoading(true);

    fetch(`${BASE_URL}/products`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 200 && Array.isArray(data.data)) {
          const mappedProducts = data.data.map((p) => ({
            id: p.id,
            name: p.name,
            content: p.content,
            price: p.price,
            category: p.category,
            image: `${UPLOAD_URL}/products/${p.image}`,
          }));
          setProducts(mappedProducts);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching products:", err);
        setLoading(false);
      });
  }, [id]);

  return (
    <ProductContext.Provider value={{ product, products, loading }}>
      {children}
    </ProductContext.Provider>
  );
};
